import { useTranslate } from "ra-core";
import { ListEmptyState } from "../design/ListStates";
import { TasksListByDueDate } from "./TasksListByDueDate";

export const TasksListContent = () => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col gap-4">
      <TasksListByDueDate
        emptyPlaceholder={
          <ListEmptyState
            title={translate("resources.tasks.empty_list_hint")}
          />
        }
      />
    </div>
  );
};
